import {Component} from "@angular/core";
import {PreparationModifierEntityModel} from "../preparation-modifier-entity-model.service";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {PreparationModifierValuesSearchModel} from "../preparation-modifier-values-search-model.service";

@Component({
    selector: "wbo-preparation-modifier-values-search-page",
    templateUrl: "./preparation-modifier-values-search-page.component.html",
    providers: [provideSearchModel(PreparationModifierValuesSearchModel), provideEntityModel(PreparationModifierEntityModel)]
})
export class PreparationModifierValuesSearchPageComponent extends AbstractSearchPage {

    showTypeFilter: boolean = true;

    constructor(private searchModel: PreparationModifierValuesSearchModel) {
        super();
    }

    prepareInitialFilter(): void {
        if (this.isSelectMode()) {
            if (this.extendedSearchParams.searchParams) {
                this.searchModel.filter["type"] = this.extendedSearchParams.searchParams["type"];
            }
            this.showTypeFilter = false;
        }
    }
}
